import { useId } from 'react';
import { Select, Tooltip } from 'antd';

import { useAnnotationSessionStore } from '@stores/useAnnotationSessionStore';
import { ANNOTATION_BOX_FILTER } from '@utils/constants';

const OPTIONS = [
	{ label: 'All', value: ANNOTATION_BOX_FILTER.ALL },
	{ label: 'Annotations', value: ANNOTATION_BOX_FILTER.ANNOTATIONS },
	{ label: 'Detections', value: ANNOTATION_BOX_FILTER.DETECTIONS },
];

const HINT = 'Which boxes the map shows: all of them, the annotations, or the detections.';
export const LOCKED_HINT = 'Save or discard your box changes, and deselect the box, to switch.';

/**
 * Which boxes the map draws in an object annotation session: every box, only
 * the annotators' rows, or only the model's detections. Hiding one kind keeps
 * a busy tile readable; the hidden boxes stay in the session and are saved as
 * before.
 *
 * Locked while the user works on a box (one is selected, or the open tile has
 * changes that are not saved), so the boxes in hand do not vanish mid-edit.
 */
const AnnotationDataSwitch = () => {
	const boxFilter = useAnnotationSessionStore(s => s.boxFilter);
	const setBoxFilter = useAnnotationSessionStore(s => s.setBoxFilter);
	const locked = useAnnotationSessionStore(s => s.edited || s.selectedBoxId !== null);
	// The lock reason for assistive tech: a disabled select takes no hover or focus.
	const lockedHintId = useId();

	return (
		<Tooltip title={locked ? LOCKED_HINT : HINT}>
			{/* Wrapped so the tooltip shows while the select is disabled. */}
			<span>
				<Select
					aria-label="Boxes shown on the map"
					aria-describedby={locked ? lockedHintId : undefined}
					options={OPTIONS}
					value={boxFilter}
					disabled={locked}
					onChange={setBoxFilter}
					popupMatchSelectWidth={false}
				/>
				{locked && (
					<span id={lockedHintId} hidden>
						{LOCKED_HINT}
					</span>
				)}
			</span>
		</Tooltip>
	);
};

export default AnnotationDataSwitch;
